module.exports = {"name":"pages","version":"1.0.0","dependencies":{}}


//////////////////
// WEBPACK FOOTER
// ./src/topdoor/pages/package.json
// module id = Ql6j
// module chunks = 1